import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const adCompensationApis = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/ad-reward-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(
            error.response.status,
            error.response.data,
            error.response.koMessage,
          );
        }
      }),
  update: (rows) =>
    ifyouApi
      .post(`${ADMIN}/ad-reward-update`, { rows: rows })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(
            error.response.status,
            error.response.data,
            error.response.koMessage,
          );
        }
      }),
};
